import React,{Component} from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";

import Button from '@material-ui/core/Button';
import TextField from "@material-ui/core/TextField";
import MenuItem from '@material-ui/core/MenuItem';

import Api from "../../../libraries/api";
import ErrorHandling from "../../../libraries/error-handling";
import { history } from "../../../shared/configure-store";
import defaultImage from "../../../images/images.png";

require('dotenv').config();
const validator = new SimpleReactValidator({locale: process.env.REACT_APP_LOCALE});

class SignatureEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loadingButton: false,
            errors: {},

            id: '',
            description: '',
            signee: '',
            materai: false,
            signatureImg: '',
            signatureFile: null,
            signatureFileName: '',

            loading: true,
            loadingButton: false,
            errors: {},
        
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSelectSignature = this.handleSelectSignature.bind(this);
    }

    componentDidMount() {
        document.title = 'Abadi - Edit Signature';

        const id = this.props.match.params.id;

        Api.get('/signatures/'+id).then(resp => {
            if (resp.data) {
                let data = resp.data;
                this.setState({
                    id: data?.id,
                    description: data?.description,
                    signee: data?.signee,
                    materai: data?.materai === 1 || data?.materai === true,
                    signatureImg: data?.signature !== null ? process.env.REACT_APP_API_STORAGE_PATH+data.signature : '',
                });
            }
        }).catch(err => {
            console.log(err);
        });
    }

    handleChange (e, prop){
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        this.setState({ [prop]: value });
    };

    handleToggleSelectSignature = () => {
        document.getElementById('signature').click();
    };

    handleSelectSignature = e => {
        const file = e.target.files[0];
        if (file && (file.type === 'image/jpeg' || file.type === 'image/png')) {
            this.setState({
                signatureImg: URL.createObjectURL(file),
                signatureFile: file,
                signatureFileName: file.name
            });
        } else {
            this.setState({
                signatureImg: '',
                signatureFile: null,
                signatureFileName: ''
            });
            this.showMessage(false, 'Only JPG and PNG images are allowed.');
        }
    };

    handleDeleteFileSignature = () => {
        this.setState({
            signatureImg: defaultImage,
            signatureFile: null,
            signatureFileName: '',
        });
    };

    showMessage = (status, message) => {
        if (status) toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT });
        else toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        const id = this.props.match.params.id;
        if (!validator.allValid()) {
            this.setState({ errors: validator.getErrorMessages() });
            return false;
        }

        this.setState({ errors: {}, loadingButton: true });

        let formData = new FormData();
        formData.append('description', this.state.description);
        formData.append('signee', this.state.signee);
        formData.append('materai', this.state.materai ? '1' : '0');
        if (this.state.signatureFile) formData.append('signature', this.state.signatureFile);

        Api.putFile(`/signatures/${id}`, {
            method: 'POST',
            body: formData
        }).then((resp) => {
            this.setState({ loadingButton: false });
            history.push('/signatures');
            this.showMessage(true, 'Signature updated');
        }).catch(err => {
            console.log(err);
            if (ErrorHandling.checkErrorTokenExpired(err)) {
            } else {
                this.setState({ errors: err.errors, loadingButton: false });
                this.showMessage(false, 'Invalid format data');
            }
        });
    };

    handleGo  = (link) => {
        history.push(link);
    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12 px-lg-5">
                    <h1 className="page-title">Edit Signature</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/signatures">Signature</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Edit</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 mt-3 px-lg-5">
                    <div className="table-wrapper">
                        <form name="edit" id="editType" className="row" noValidate>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Description</label>
                                    <TextField
                                        variant="outlined"
                                        type='text'
                                        id='description'
                                        name="description"
                                        label="Description"
                                        autoComplete="off"
                                        onChange={(e) => this.handleChange(e, 'description')}
                                        value={this.state.description}
                                        fullWidth
                                    />
                                    {validator.message('description', this.state.description, 'required')}
                                    <div className='text-danger'>{this.state.errors.description}</div>
                                </div>
                            </div>
                            <div className="col-md-6"></div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Signee</label>
                                    <TextField
                                        variant="outlined"
                                        type='text'
                                        id='signee'
                                        name="signee"
                                        label="Signee"
                                        autoComplete="off"
                                        onChange={(e) => this.handleChange(e, 'signee')}
                                        value={this.state.signee}
                                        fullWidth
                                    />
                                    {validator.message('signee', this.state.signee, 'required')}
                                    <div className='text-danger'>{this.state.errors.signee}</div>
                                </div>
                            </div>
                            <div className="col-md-6"></div>
                            <div className="col-md-6">
                                <div className="d-flex">
                                    <div>
                                        <input
                                            type="checkbox"
                                            id="materai"
                                            name="materai"
                                            checked={this.state.materai}
                                            onChange={e => this.handleChange(e, 'materai')}
                                            style={{width: '20px', height: '20px'}}
                                        />
                                    </div>
                                    <div className="ml-2 mb-2">Dengan Materai</div>
                                    {validator.message('materai', this.state.materai, 'boolean')}
                                    <div className='text-danger'>{this.state.errors.materai}</div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Signature Image (Foto Tanda Tangan)</label>
                                    <div className="mb-3">
                                        <img
                                            style={{width: '200px', height: '200px', cursor: 'pointer'}}
                                            src={this.state.signatureImg || ''}
                                            alt="Signature"
                                            onClick={this.handleToggleSelectSignature}
                                        />
                                    </div>
                                    <div>
                                        <input
                                            type="file"
                                            id="signature"
                                            name="signature"
                                            accept="image/jpeg, image/png"
                                            onChange={this.handleSelectSignature}
                                        />
                                    </div>
                                    {validator.message('signature', this.state.signatureImg, 'required')}
                                    <div className='text-danger'>{this.state.errors.signature}</div>
                                </div>
                            </div>
                            <div className="col-12 text-center">
                                <Button className="mr-3" variant="contained" onClick={() => this.handleGo('/signatures')}>Cancel</Button>
                                <Button variant="contained" color="primary" className="mr-3" onClick={this.handleSubmit} disabled={this.state.loadingButton && 'disabled' }>
                                    Submit{ this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i> }
                                </Button>
                            </div>
                            <ToastContainer autoClose={3000} />
                        </form>
                    </div>
                </div>
                <ToastContainer autoClose={3000} />
            </div>
        )
    }
}

export default SignatureEdit;